<template>
  <div class="flex flex-col w-full px-16 md:px-8">
    <div class="flex flex-row items-center">
      <TitreDeux :content="t('mydraft')" class="text-center" />
    </div>

    <BlueSpacer class="w-4/5" />

    <AnimatedList class="flex-col mt-4 gap-2 w-4/5">
      <div class="flex flex-row mx-2 items-center cursor-pointer" v-on:click="brouillonsStores.brouillonsSelected = 0">
        <GreenPlusIcon class="w-[24px] h-[24px] mr-2" />
        <SimpleText :content="t('newOrder')" :selectable="false" />
      </div>
      <BrouillonIdCard v-for="brouillon in brouillonsStores.brouillons" :key="brouillon.uuid" :brouillon="brouillon" />
    </AnimatedList>
  </div>
</template>

<script setup>

import TitreDeux from "@/components/atoms/TitreDeux.vue";
import {t} from "@/utils/Traduction";
import BlueSpacer from "@/components/atoms/BlueSpacer.vue";
import {BrouillonStore} from "@/stores/BrouillonStore";
import BrouillonIdCard from "@/components/molecules/BrouillonIdCard.vue";
import GreenPlusIcon from "@/components/atoms/GreenPlusIcon.vue";
import SimpleText from "@/components/atoms/SimpleText.vue";
import AnimatedList from "@/components/molecules/AnimatedList.vue";

const brouillonsStores = BrouillonStore();

brouillonsStores.loadBrouillons();

</script>

<style scoped>
</style>